import ApiMakerBootstrapInput from "@kaspernj/api-maker/build/bootstrap/input.js"

export default function BootstrapInput({labelClassName, ...restProps}) {
  return (
    <ApiMakerBootstrapInput labelClassName={classNames("form-label", labelClassName)} {...restProps} />
  )
}
